//ValuesScreen

import { Switch, Route, useRouteMatch } from "react-router-dom";

import routes from "./URL";
import { HotelProfileScreen, CreateHotelScreen } from "../screens/HotelScreens";

import { SubscriptionPlanSCreen } from "../screens/SubscriptionScreens";

import {

    UserListScreen,
    UserListViewScreen
} from "../screens/SettingScreens";


export default function gallery_image_routes() {
    return (
        <Switch>



      <Route
                path={routes.admin.customers.view(":hotelSlug", ":customerSlug")}
                component={UserListViewScreen}
            />

            <Route
                path={routes.admin.customers.root(":hotelSlug")}
                component={UserListScreen}
            />
      

        </Switch>
    );
}
